export default "/images/lang.svg?fe922a83442e09d014b30363e70f4c91";